<template>
  <div class="sub-page">
    <div class="sub-header" style="background-image: url('/img/mine/login-bg.png'), linear-gradient(90deg, rgb(79, 43, 138), rgb(245, 96, 205));">
      <van-nav-bar :title="$t('setting.login_pwd_tip') || '修改登錄密碼'" class="sub-nav">
        <template #left>
          <van-icon name="arrow-left" color="#fff" @click="back()"/>
        </template>
      </van-nav-bar>
    </div>

    <div class="sub-body">
      <div class="card form-card">
        <div class="form-item">
          <label>*{{$t("setting.old_pwd")}}</label>
          <van-field
            v-model="old_password"
            type="password"
            :placeholder="$t('setting.old_pwd_tip')"
            class="van-cell--borderless"
          />
        </div>

        <div class="form-item">
          <label>*{{$t("setting.new_pwd")}}</label>
          <van-field
            v-model="o_new_password"
            type="password"
            :placeholder="$t('setting.new_pwd_tip')"
            class="van-cell--borderless"
          />
        </div>

        <div class="form-item">
          <label>*确认新密码</label>
          <van-field
            v-model="t_new_password"
            type="password"
            :placeholder="$t('setting.new_again_tip')"
            class="van-cell--borderless"
          />
        </div>

        <button type="button" class="submit-btn" @click="save()"> {{$t("my.msg42") || '保存'}} </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      o_new_password:"",
      t_new_password:"",
      old_password:"",
      userInfo:{}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    save(){
      if(!this.old_password){
        this.$toast.fail(this.$t("setting.prefect"));
        return false;
      }
      if(!this.o_new_password){
        this.$toast.fail(this.$t("setting.prefect"));
        return false;
      }
      if(!this.t_new_password){
        this.$toast.fail(this.$t("setting.prefect"));
        return false;
      }
      if(this.o_new_password !== this.t_new_password){
        this.$toast(this.$t("setting.pwd_error"));
        return false;
      }
      this.$http({
        method: 'get',
        data:{
          old_password:this.old_password,
          new_password:this.o_new_password,
        },
        url: 'user_set_loginpw'
      }).then(res=>{
        if(res && res.code === 200){
          this.$toast.success(res.msg || '修改成功');
          setTimeout(() => {
            localStorage.clear()
            this.$router.push("Login")
          }, 500);
        }else if(res){
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res && res.code === 200){
          this.userInfo = res.data;
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
    }
  }
};
</script>

<style scoped>
.sub-page {
  width: 100%;
  min-height: 100vh;
  background-color: #f3f3f5;
  padding-bottom: 60px;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Helvetica Neue", STHeiti, "Microsoft Yahei", Tahoma, Simsun, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.sub-header {
  position: relative;
  width: 100%;
  height: 220px;
  background-image: url('/img/mine/login-bg.png'), linear-gradient(90deg, rgb(79, 43, 138), rgb(245, 96, 205));
  background-size: 100% auto;
  background-position: center bottom;
  background-repeat: no-repeat;
  box-sizing: border-box;
}

.sub-nav {
  background: transparent !important;
  height: 100px;
}

::v-deep .sub-nav .van-nav-bar__content {
  height: 100px;
}

::v-deep .sub-nav .van-nav-bar__title {
  color: #ffffff !important;
  font-size: 34px !important;
  font-weight: 600 !important;
  line-height: 100px;
}

::v-deep .sub-nav .van-icon {
  color: #ffffff !important;
  font-size: 44px !important;
}

.sub-body {
  padding: 0 30px;
  margin-top: -60px;
  position: relative;
  z-index: 10;
}

.form-card {
  background: #ffffff;
  border-radius: 24px;
  padding: 40px 30px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);
}

.form-item {
  margin-bottom: 24px;
}

.form-item label {
  display: block;
  font-size: 28px;
  color: #333333;
  margin-bottom: 12px;
  font-weight: 500;
}

.form-item .van-cell {
  background: #f7f7f9;
  border-radius: 16px;
  padding: 20px 24px;
}

::v-deep .form-item .van-field__control {
  font-size: 28px;
  color: #333333;
}

.submit-btn {
  display: block;
  width: 100%;
  height: 90px;
  margin-top: 40px;
  border: none;
  border-radius: 45px;
  background: linear-gradient(90deg, #f560cd, #4f2b8a);
  color: #ffffff;
  font-size: 32px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 6px 20px rgba(245, 96, 205, 0.3);
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.submit-btn:active {
  opacity: 0.85;
  transform: scale(0.99);
}
</style>
